class GlobalStrategy {
  /**
   * Singleton for Stregy on override methods detection
   * @param Vue
   */
  constructor(Vue) {
    this.oldVersion = Vue.config.optionMergeStrategies.methods;
    Vue.config.optionMergeStrategies.methods = (toVal, fromVal) =>
      this.detectOverride(toVal, fromVal);
  }

  /**
   * strategy on override methods
   * @param toVal
   * @param fromVal
   * @returns {*}
   */
  detectOverride(toVal, fromVal) {
    if (!toVal) return fromVal;
    if (!fromVal) return toVal;
    return this.oldVersion(toVal, fromVal);
  }

  /**
   * install the plugin for Strategy and detect override on methods
   * TODO detect computed override
   * @param Vue
   */
  static install(Vue) {
    this._instance = new GlobalStrategy(Vue);
  }
}

export default {
  install: (Vue) => GlobalStrategy.install(Vue),
};
